import { lazy, Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import "react-toastify/dist/ReactToastify.css";
import Referral from "./pages/Referral";
import Market from "./pages/Greyhound/Market";
import Loader from "../../AsianExchangeSrc/utils/Loader";
import ProtectedRoute from "../../AsianExchangeSrc/components/ProtectedRoute/ProtectedRoute";
import SignupProtectedRoute from "../../CommonComponents/SignupProtectedRoute";
import SportsTv from "../../CommonComponents/SportsTv";
import TvNotFound from "../../AsianExchangeSrc/pages/TVnotFound";

// Lazy load components
import Home from "./pages/Home";
import InPlay from "./pages/InPlay";
import Today from "./pages/Today";
import Tomorrow from "./pages/Tomorrow";
const Fullmarket = lazy(() => import("./pages/Fullmarket"));
const Fullmarket2 = lazy(() => import("./pages/Fullmarket2"));
import Cricket from "./pages/Cricket";
const Multimarket = lazy(() => import("./pages/Multimarket"));
import Soccer from "./pages/Soccer";
import Tennis from "./pages/Tennis";
const ESoccer = lazy(() => import("./pages/ESoccer"));
const Kabaddi = lazy(() => import("./pages/kabaddi"));
const VirtualCricket = lazy(() => import("./pages/VirtualCricket"));
const MyAccount = lazy(() => import("./pages/MyAccount"));
const Summary = lazy(() => import("./pages/Summary"));
const AccountCashStatement = lazy(() => import("./pages/AccountCashStatement"));
const Current_bets = lazy(() => import("./pages/MyBeat/Current_bets"));
const Bets_history = lazy(() => import("./pages/MyBeat/Bets_history"));
const Profit_loss = lazy(() => import("./pages/MyBeat/Profit_loss"));
const AuthLogin = lazy(() => import("./pages/AuthLogin"));
const Profile = lazy(() => import("./pages/Profile"));
const Livebeat = lazy(() => import("./pages/LiveMatchs/Livebeat/Livebeat"));
const Dragon = lazy(() => import("./pages/LiveMatchs/Dragon/Dragon"));
const Poker = lazy(() => import("./pages/LiveMatchs/Poker/Poker"));
const Baccarat = lazy(() => import("./pages/LiveMatchs/Baccarat/Baccarat"));
const Instantworli = lazy(() =>
  import("./pages/LiveMatchs/Instantworli/Instantworli")
);
const ActivityLog = lazy(() => import("./pages/ActivityLog"));
const SignUp = lazy(() => import("./pages/SignUp"));
import Horse from "./pages/Horse/Horse";
const HorseGame = lazy(() => import("./components/MatchSchulte/HorseGame"));
import Greyhound from "./pages/Greyhound/Greyhound";
import ResultToday from "./pages/Results/ResultToday";
import ResultYesterday from "./pages/Results/ResultYesterday";
import ResultFiveDays from "./pages/Results/ResultFiveDays";
const PlayCasino = lazy(() => import("./pages/UniqueCasino/PlayCasino"));
const NewCasino = lazy(() => import("./pages/NewCasino/Casino"));
const BalanceOverview = lazy(() =>
  import("./pages/BalanceOverview/BalanceOverview")
);

const Withdrawal = lazy(() => import("./pages/BalanceOverview/WithdrawNew"));
const BankTransfer = lazy(() => import("./pages/BankTransfer"));

const LiveCasino = lazy(() => import("./pages/LiveCasino/LiveCasino"));
const Casino = lazy(() => import("./pages/Casino/Casino"));
const GameLobby = lazy(() => import("./pages/CasinoList/GameLobby"));

export const SkyExchnageRoutes = createBrowserRouter([
  {
    path: "/tv",
    element: <SportsTv />,
  },
  {
    path: "/tv-not-found",
    element: <TvNotFound />,
  },
  {
    path: "/",
    element: <App />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "in-play",
        element: <InPlay />,
      },
      {
        path: "Today",
        element: <Today />,
      },
      {
        path: "tomorrow",
        element: <Tomorrow />,
      },
      {
        path: "fullMarket",
        element: (
          <Suspense fallback={<Loader />}>
            {/* <Fullmarket /> */}
            <Fullmarket2 />
          </Suspense>
        ),
      },
      // {
      //   path: "fullMarket2",
      //   element: (
      //     <Suspense fallback={<Loader />}>
      //       <Fullmarket2 />
      //     </Suspense>
      //   ),
      // },
      {
        path: "/cricket",
        element: <Cricket />,
      },
      {
        path: "multi-markets",
        element: (
          <Suspense fallback={<Loader />}>
            <Multimarket />
          </Suspense>
        ),
      },
      {
        path: "Soccer",
        element: <Soccer />,
      },
      {
        path: "tennis",
        element: <Tennis />,
      },
      {
        path: "/horse",
        element: <Horse />,
      },

      {
        path: "/result/today",
        element: <ResultToday />,
      },
         {
        path: "/result/yesterday",
        element: <ResultYesterday />,
      },
          {
        path: "/result/fiveDays",
        element: <ResultFiveDays />,
      },
      {
        path: "greyhound",
        element: <Greyhound />,
      },
      {
        path: "horseGame",
        element: (
          <Suspense fallback={<Loader />}>
            <HorseGame />
          </Suspense>
        ),
      },
      {
        path: "e-soccer",
        element: (
          <Suspense fallback={<Loader />}>
            <ESoccer />
          </Suspense>
        ),
      },
      {
        path: "kabaddi",
        element: (
          <Suspense fallback={<Loader />}>
            <Kabaddi />
          </Suspense>
        ),
      },
      {
        path: "virtual-cricket",
        element: (
          <Suspense fallback={<Loader />}>
            <VirtualCricket />
          </Suspense>
        ),
      },
      {
        path: "myAccount/profile",
        element: (
          <Suspense fallback={<Loader />}>
            <MyAccount />
          </Suspense>
        ),
      },
      {
        path: "myAccount/summary",
        element: (
          <Suspense fallback={<Loader />}>
            <Summary />
          </Suspense>
        ),
      },
      {
        path: "myAccount/activityLog",
        element: (
          <Suspense fallback={<Loader />}>
            <ActivityLog />
          </Suspense>
        ),
      },
      {
        path: "new-casino",
        element: (
          <Suspense fallback={<Loader />}>
            <NewCasino />
          </Suspense>
        ),
      },
      {
        path: "casino-games/live-casino",
        element: (
          <Suspense fallback={<Loader />}>
            <LiveCasino />
          </Suspense>
        ),
      },
      {
        path: "casino-games",
        element: (
          <Suspense fallback={<Loader />}>
            <Casino />
          </Suspense>
        ),
      },
      {
        path: "play-casino-new/:eventId/:casinoType",
        element: (
          <Suspense fallback={<Loader />}>
            <PlayCasino />
          </Suspense>
        ),
      },
      {
        path: "myAccount/accountCashStatement",
        element: (
          <ProtectedRoute navigateTo="/login">
            <Suspense fallback={<Loader />}>
              <AccountCashStatement />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "myAccount/current_bets",
        element: (
          <ProtectedRoute navigateTo="/login">
            <Suspense fallback={<Loader />}>
              <Current_bets />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "myAccount/bets-history",
        element: (
          <ProtectedRoute navigateTo="/login">
            <Suspense fallback={<Loader />}>
              <Bets_history />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "myAccount/profit-loss",
        element: (
          <ProtectedRoute navigateTo="/login">
            <Suspense fallback={<Loader />}>
              <Profit_loss />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "myAccount/bank-transfer",
        element: (
          <ProtectedRoute navigateTo="/login">
            <Suspense fallback={<Loader />}>
              <BankTransfer />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/login",
        element: (
          <Suspense fallback={<Loader />}>
            <AuthLogin />
          </Suspense>
        ),
      },
      {
        path: "/signUp",
        element: (
          <Suspense fallback={<Loader />}>
            <SignUp />
          </Suspense>
        ),
      },
      {
        path: "/profile",
        element: (
          <ProtectedRoute navigateTo="/login">
            <Suspense fallback={<Loader />}>
              <Profile />
            </Suspense>
          </ProtectedRoute>
        ),
      },

      {
        path: "/livebeat",
        element: (
          <Suspense fallback={<Loader />}>
            <Livebeat />
          </Suspense>
        ),
      },
      {
        path: "/dragon",
        element: (
          <Suspense fallback={<Loader />}>
            <Dragon />
          </Suspense>
        ),
      },
      {
        path: "/poker",
        element: (
          <Suspense fallback={<Loader />}>
            <Poker />
          </Suspense>
        ),
      },
      {
        path: "/baccarat",
        element: (
          <Suspense fallback={<Loader />}>
            <Baccarat />
          </Suspense>
        ),
      },
      {
        path: "/instant-Worli",
        element: (
          <Suspense fallback={<Loader />}>
            <Instantworli />
          </Suspense>
        ),
      },
      {
        path: "/balance-overview",
        element: (
          <SignupProtectedRoute>
            <Suspense fallback={<Loader />}>
              <BalanceOverview />
            </Suspense>
          </SignupProtectedRoute>
        ),
      },
      {
        path: "/withdraw",
        element: (
          <Suspense fallback={<Loader />}>
            <Withdrawal />
          </Suspense>
        ),
      },
      {
        path: "/Market",
        element: (
          <Suspense fallback={<Loader />}>
            <Market />
          </Suspense>
        ),
      },
      { path: "/referral", element: <Referral /> },
    ],
  },
  {
    path: "/game-lobby",
    element: (
      <Suspense fallback={<Loader />}>
        <GameLobby />
      </Suspense>
    ),
  },
]);
